import { select, call, takeLatest } from "redux-saga/effects";
import { selectToken } from "../../../../redux-store/selectors";
import {
  submitPickupBranches,
  submitPickupBranchesFailure,
  submitPickupBranchesSuccess,
  ISelectedBranchesMap,
} from "../actions/pickupBranchesActions";
import { toggleOrderingServicesAPI } from "../../axios/toggleOrderingServices";
import { handleOptimism } from "./handleOptimism";
import { BranchSelectionMap } from "../../../../types/audit";
import { buildScheduledServicesPayload } from "../../../../helpers/audit/utils";


function* submitPickupBranchesSaga(action: any) {
  const token = yield select(selectToken);
  const selectedBranchesMap: ISelectedBranchesMap =
    yield select((state: any) => state.selectedBranchesMapReducer);
  const __prevServiceBaseline = selectedBranchesMap as unknown as BranchSelectionMap;

  const serviceAudit = yield select((state: any) => state.serviceAuditReducer);
  const branches = yield select((state: any) => state.branchesReducer.allBranches);

  const scheduled_services = buildScheduledServicesPayload(
    serviceAudit.scheduledDisables,
    serviceAudit.disableMetadata,
    {
      branches,
      enableOverrides: serviceAudit.enableOverrides,
    }
  );

  const res = yield call(toggleOrderingServicesAPI, token, {
    ...action.payload,
    scheduled_services,
  });
  if (res.status !== 200) {
    throw new Error(
      `toggleOrderingServices failed with status ${res.status}`
    );
  }

  return { ...action.payload, __prevServiceBaseline };
}

export function* watchSubmitPickupBranchesSaga() {
  yield takeLatest(
    submitPickupBranches.type,
    handleOptimism(submitPickupBranchesSaga, {
      failure: submitPickupBranchesFailure as any,
      success: submitPickupBranchesSuccess as any,
    })
  );
}
